import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

export function setupScene(mountRef) {
  // Scene
  const scene = new THREE.Scene();
  scene.background = new THREE.Color(0xf5f5f7);

  // Camera
  const camera = new THREE.PerspectiveCamera(
    75,
    mountRef.clientWidth / mountRef.clientHeight,
    0.1,
    10000
  );
  camera.up.set(0, 0, 1);
  camera.position.set(100, -100, 100);

  // Renderer
  const renderer = new THREE.WebGLRenderer({ antialias: true });
  renderer.setSize(mountRef.clientWidth, mountRef.clientHeight);
  mountRef.appendChild(renderer.domElement);

  // Controls
  const controls = new OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true;
  controls.dampingFactor = 0.05;

  // Lighting
  scene.add(new THREE.AmbientLight(0xffffff, 0.6));
  const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
  directionalLight.position.set(100, 100, 50);
  scene.add(directionalLight);

  // Grid & Axes
  const grid = new THREE.GridHelper(200, 20, 0xcccccc, 0xe0e0e0);
  grid.rotation.x = -Math.PI / 2;
  scene.add(grid);
  scene.add(new THREE.AxesHelper(100));

  return { scene, camera, renderer, controls };
}

export function animateScene(renderer, scene, camera, controls) {
  const animate = () => {
    requestAnimationFrame(animate);
    controls.update();
    renderer.render(scene, camera);
  };
  animate();
}

export function centerAndFitModel(object, controls) {
  const box = new THREE.Box3().setFromObject(object);
  const center = box.getCenter(new THREE.Vector3());
  const size = box.getSize(new THREE.Vector3());

  object.position.sub(center);

  const maxDim = Math.max(size.x, size.y, size.z);
  const camera = controls.object;
  camera.up.set(0, 0, 1);
  camera.position.set(maxDim * 1.5, -maxDim * 1.5, maxDim * 1.5);
  controls.target.set(0, 0, 0);
  controls.update();
}
